<template>
    <div class="welcome-container" >
        <HeaderCustom></HeaderCustom>
        <div class="banner">
            <div class="box-container">
                <h1 class="main-title">DediCOATED</h1>
                <div class="banner-sep"></div> 
                <h2>A UNIQUE DIGITAL EXPERIENCE</h2>
                <br />
                <p class="sub">100% DEDICATED FOR COATED ABRASIVE MANUFACTURERS</p>
            </div>
        </div>
        <div class="event-container" ref="event" id="event">
            <div class="box-container">
            
                <div class="row">
                    <div class="col-50">
                        <div class="video-item">
                            <div class="video-click" @click="displayVideo = true"></div>
                            <youtube 
                                video-id="AQKuzo32OjI"
                                ref="youtube"
                                :fitParent="true" >
                            </youtube>
                        </div>
                    </div>
                    <div class="col-50">
                        <div class="video-text">
                            <p><span class="video-title">QUALITATIVE</span> 100% designed for manufacturers of coated abrasives</p>
                            <p><span class="video-title">ACCESSIBLE</span> Online with replays for sharing worldwide and across the board</p>
                            <p><span class="video-title">INTERACTIVE</span> 2 live sessions on each theme for all geographical areas with private Q&A sessions</p>
                            <p><span class="video-title">PERSONALIZED</span> Your contacts a click away, to organize private meetings</p>
                            <p><span class="video-title">UNTERTAINING</span> Your loyalty rewarded * Play & Win!</p>
                        </div>
                    </div>
                </div>
          
            </div>
        </div>
        <div class="wheel-container">
            <div class="box-container">
                <h2>OPTIMIZE YOUR<br /> SUPPLY-CHAIN & PROCESS </h2>
                <div class="row">                
                    <div class="col-50 ">                    
                        <img src="./../assets/img/process.gif" alt="wheel process" class="wheel-process" />
                    </div>
                    <div class="col-50">  
                        <p>Several suppliers on a same platform</p>  
                        <p>Combined themes : resin * grains * machine * process</p>
                        <p>Online technical sessions on a variety of solutions</p>      
                    </div>
                </div>  
            </div>
        </div>
        <div class="box-container box-content">
            <h2>MAKE YOUR PROJECTS A SUCCESS</h2>
            <div class="row">
                <div class="col-33">
                    <div class="box">
                        <h4>Shared conferences</h4>
                        <p>For a cross-view on technical topics </p>
                    </div>
                </div>
                <div class="col-33">
                    <div class="box">
                        <h4>Specialized presentations</h4>
                        <p>To find solutions and innovations</p>
                    </div>
                </div>
                <div class="col-33">
                    <div class="box">
                        <h4>Private meetings</h4>
                        <p>With your contacts for individual answers & business contacts</p>
                    </div>
                </div>
            </div>  
        </div>
        <div class="box-container box-content">
            <h2>GENERATE MORE IDEAS</h2>
            <div class="row">
                <div class="col-33">
                    <div class="box">
                        <h4>Exhibitor space</h4>
                        <p>To get to know your partners (again) at your own pace </p>
                    </div>
                </div>
                <div class="col-33">
                    <div class="box">
                        <h4>Networking tool</h4>
                        <p>Get in touch with the community, targeting your contacts and organizing parallel meetings</p>
                    </div>
                </div>
                <div class="col-33">
                    <div class="box">
                        <h4>Market insights </h4>
                        <p>Learn about final market and trends with our guest speakers</p>
                    </div>
                </div>
            </div>  
        </div>
        <!-- <div class="discover-edition">
            <div class="box-container">
                <h2>How to follow the event ?</h2>
                <div class="row row-center">
                    <router-link to="/edition2023#join">DediCOATED 2023</router-link>
                </div>
            </div>            
        </div> -->
        <div class="convention-help">
            <div class="box-container">
                <h2>DediCOATED 3.0 Is a break-through<br /> convention which helps to</h2>
                <img src="./../assets/img/figure-help.png" alt="figure help" />
            </div>            
        </div>
        <div class="testimonials">
            <div class="box-container">
                <h2>Testimonials</h2>
                <div class="testimonials-container">
                    <div class="testimonials-item" v-for="(item, idx) in testimonials " :key="idx">
                        <div class="testimonials-content">
                            <img :src="require(`./../assets/img/${item.logo}`)" alt="logo" />
                            <h3>{{ item.name}}</h3>
                            <p class="job" v-html="item.job"></p>
                            <p v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="organizer">
            <div class="box-container">
                <h2>organizer</h2>
                <h3><strong>DediCOATED 3.0</strong> is an event organised by Ahlstrom</h3>
                <a href="https://www.ahlstrom.com/products/abrasive-backing/" class="btn-banner btn-banner-blue" target="_blank">Find out more</a>
                <div class="row">
                    <div class="col-50">
                        <p>Ahlstrom is a global company in fiber-based materials, supplying innovative standard and tailormade solutions for sustainable everyday life.</p>
                        <p>We are delivering formaldehyde free coated abrasive backings, including paper and composites for wet or dry applications and for DIY to the most demanding professional business. In 2020 we added to our range blotters for bonded abrasives.</p>
                    </div>
                    <div class="col-50">
                        <p>Our abrasives business is centered on values that we hold dear: innovation, expertise and the exchange of ideas. This online trade fair has been packed with useful contents and enriching meetings with the desire to create close ties with our customers and offer a "wide-angle" vision from the supply-chain.</p>
                        <p class="blue-text">53-300g/m<sup>2</sup> * latex papers * antistatic papers * saturating bases * composites for combinations & cloth alternatives * blotters </p>
                    </div>
                </div>
                <p class="organizer-links">To learn more about our values and solutions read the extract of our <a href="https://www.ahlstrom.com/products/abrasive-backing/extract-from-abrasive-newsletter-the-a-vision-n020-special-trade-show-dedicoated-2023/" target="_blank">dedicoated newsletter</a> and ask for the <a href="mailto:contact.abrasives@ahlstrom.com?subject=Full version of the Newsletter No 20 Special Trade Fair DediCOATED" target="_blank">integral version</a>.</p>
            </div>
        </div>
        

        <FooterCustom></FooterCustom>
        <VideoModal v-if="displayVideo" :video="video" v-on:closeModalVideo="closeModalVideo"></VideoModal>
    </div>
</template>


<script>
import lang from './../lang'
import config from './../conventionsConfig'
import store from './../store'
import HeaderCustom from './../components/HeaderCustom'
import FooterCustom from './../components/FooterCustom'
import VideoModal from './../components/VideoModal'

export default {
    name : 'Welcome',
    components : {HeaderCustom, FooterCustom, VideoModal},
    data() {
        return {
            ready : false,
          
            displayVideo : false,
            video : {
                name : 'DediCOATED A Virtual Trade Show',
                type : 'link/yt',
                path: 'https://youtu.be/AQKuzo32OjI'
            },
            testimonials : [
                {
                    logo : 'testi1.jpg',
                    name : 'Juan Mock D.',
                    job : 'Quality Manager',
                    desc : 'It has been an enriching experience to take direct contact with our suppliers - references.<br />With a totally dynamic round trip. between our doubts and possible solutions. I felt that I was present.'
                },
                {
                    logo : 'testi5.jpg',
                    name : 'Paolo Cipollina',
                    job : 'R&D Manager',
                    desc : 'The whole structure and organization is impressive: a great effort and job done!'
                },
                {
                    logo : 'testi2.jpg',
                    name : 'Caglar ALMIS',
                    job : 'Process and Product Development Manager',
                    desc : 'All critical components such as maker, resin, paper and grain were represented perfectly in the meeting of coated abrasive industry professionals under a single roof : DediCOATED.'
                },
                {
                    logo : 'testi3.jpg',
                    name : 'Ergin Özgen',
                    job : 'Business Development & Product Manager for Coated Abrasives',
                    desc : 'DediCOATED was a well-prepared event, congrats for all the team. Strong topics, excellent infrastructure and perfect flow'
                },
                {
                    logo : 'testi4.jpg',
                    name : 'Kuitian (KT) Tan, Ph.D.',
                    job : 'Group Leader/Principal Scientist',
                    desc : 'Thanks for organizing this virtual event esp. during the current pandemic. It creates opportunities for people to connect, network, and get to know what is going on in other areas around the coated abrasives supply chain. As a new comer to the abrasives industry (5 months when the event started), I personally think the lecture contents and the selection of the speakers are both great. The lectures cover a broad range of topics and in the meanwhile, there are some fun elements built in to keep the audience focused and entertained.'
                },
                {
                    logo : 'testi4.jpg',
                    name : 'Dustin Parker, P.Eng.',
                    job : 'Norton / Saint-Gobain <br /> Research & Development Engineer',
                    desc : 'I enjoyed the presentations. I was able to get some new information during each session.'
                },

            ]
        }
    },
    created() {
        this.$store.commit('deleteConfig');      
        let settings = { config, lang };
        this.$store
            .dispatch("setConfig", settings)
            .then(() => this.$store.dispatch("loadConventionInfos"))
        let vm = this
        setInterval(function(){
            if(store.state.CONFIG.welcome != 1) {
                //vm.$router.push('/login')
            }else {
                vm.ready = true
            }
        }, 1000);
 

    },
    methods: {
        scrollMeTo(refName) {
            var element = this.$refs[refName];
            element.scrollIntoView({ behavior: 'smooth' });
        },
        closeModalVideo() {
            this.displayVideo = false
        },
        openProgram() {
            window.open('https://dedicoated.my-virtual-convention.com/pdfs/MUNKSJO_Prog_A4.pdf', '_blank');            
        }
    }
}
</script>

<style lang="scss" scoped >

    .welcome-container {
        width:100%;
        
    }

    h2 {
        font-size:30px;
        color:$main-color;
        font-weight:700;
        margin:0;
        padding: 0;
        text-transform:uppercase;
    }

    p.sub {
        font-size:25px;
        color:#345d68;
        font-weight:700;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 2px;
    }





    /* BANNER */

    .banner {
        width:100%;
        background: url('./../assets/img/banner_landing.jpg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        height:800px;
        display: flex;
        align-items:center;
        margin-top:100px;
    }

    .box-container {
        width: 1450px;
        margin:0 auto;
        padding:0 40px;
        max-width: calc(100% - 80px);
    }

    .banner h1 {
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
        font-size:30px;
        font-weight:700;
        color:#fff;
        margin:0 !important;
        padding:0;
        letter-spacing: 2px;
        line-height:70px;
    }

    .banner h1.main-title {
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
        font-weight:700;
        color:#fff;
        margin:0;
        padding:0;
        letter-spacing: 2px;
        font-size:50px;
        margin-top: -80px;
		background: linear-gradient(to right,$main-color 10%, #90be6c 50%, #f6b868 60%);
		background-size: auto auto;
		background-clip: border-box;
		background-size: 200% auto;
		color: #fff;
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		animation: textclip 1.5s linear infinite;
    }

    @keyframes textclip {
        to {
            background-position: 200% center;
        }
    }


    .banner p {
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
        font-weight:400;
        font-style: italic;
        color:#fff;
        margin:0;
        padding:0;
        letter-spacing: 2px;
        font-size:30px;
    }

    .banner h1 .subtitle {
        font-size:30px;
        font-weight:400;
    }

    .banner h1 .title-quote {
        color:$main-color;
    }

    .banner-sep {
        height:1px;
        width:750px;
        background:#fff;
        margin:40px auto;
        max-width: 100%;
    }

    .banner-text {
        margin-bottom:40px;
    }

    .banner-text p{
        font-family: Arial, Helvetica, sans-serif;
        color:#fff;
        font-size:40px;
        letter-spacing: 2px;
        margin:0;
        text-align: center;
        line-height: 50px;
    }

    .banner-text p span {
        font-size:30px;
        font-family: $font-bold;
    }

    .btn-container {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }

    .btn-banner {
        width:240px;
        padding:15px 5px;
        border-radius:10px;
        background:$main-color;
        color:#fff;
        display: flex;
        justify-content: center;
        font-size:25px;
        font-family: Arial, Helvetica, sans-serif;
        text-decoration: none;
        box-shadow: 6px 0 10px rgba(0,0,0,0.3);
        transition: 0.5s;
        cursor: pointer;
        margin:0 20px;
        text-align: center;
    }

    .btn-banner:hover {
        background: darken($main-color, 20)
    }

    .btn-banner.btn-banner-blue {
        background:#345d68;
    }

    .btn-banner.btn-banner-blue:hover {
        background: darken(#345d68, 10)
    }


    /* EVENT */

    .event-container {
        padding-top:80px;
        margin-top:-80px;
    }

    .event-container .row {
        margin-top:80px;
        align-items: center;
    }

    h3.video-title {
        font-size:35px;
        color:$main-color;
        text-align: center;
        font-weight:400;
        margin:80px 0 40px 0;
        padding:0;
        font-family: $font-regular;
        letter-spacing: 2px;
    }

    .video-text p {
        font-size:20px;
        color:#345d68;
        margin:0 0 20px 0;
    }

    .video-text  {
        padding:0 20px;
    }

    .video-text p .video-title {
        color:$main-color;
        font-weight:700;
    }

    .video-item {
        position: relative;
        max-width: 100%;
    }

    .video-item iframe {
        max-width: 100%;
    }

    .video-click {
        position: absolute;
        top:0;
        bottom:0;
        right:0;
        left:0;
        cursor: pointer;
    }

    .wheel-container {
        background:#345d68;
        margin-top:80px;
        padding:80px 0;
    }

    .wheel-container .row {
        align-items: center;
    }

    .wheel-container p {
        color:#fff;
        font-size:25px;
        margin-bottom:40px;
    }

    .wheel-process {
        max-width: 100%;
    }

    .box-content {
        margin:80px auto;
    }

    .box-content h2 {
        margin-bottom:20px;
    }

    .box {
        border:1px solid #345d68;
        border-radius:10px;
        padding:20px;
        margin:20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-height:160px;
        position: relative;
    }

    .box h4 {
        color:$main-color;
        font-size:25px;
        font-weight:700;
        text-align: center;
    }

    .box p {
        color:#345d68;
        text-align: center;
        font-size:20px;
    }

    .box p .focus {
        font-size:25px;
        font-weight:700;
        color:$main-color;
        text-transform: uppercase;
    }

    .imeas-logo {
        position: absolute;
        top:-30px;
        right:-30px;
        height:80px;
        width:80px;
    }

    .col-wheel {
        background-image:url('./../assets/img/bg-wheel.jpg');
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        padding:40px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .col-wheel p {
        color:#90be6c;
        font-size:22px;
        text-align:center;
        margin:20px auto;
        text-transform: uppercase;

    }

    .col-wheel img {
        margin:20px auto 0 auto;
        width: 80%;
        height:auto;
        max-width: 500px;
    }

    .col-process img {
        margin:0 auto;
        width: 80%;
        height:auto;
        max-width: 300px;
    }

    .col-process {
        padding:40px 0;
        display: flex;
        align-items: center;
        flex-direction: column; 
    }

    .process-container {
        width: 80%;
        max-width: 500px;
    }

    .process-item {
        display: flex;
        margin-bottom:10px;
    }

    .process_num {
        font-size:20px;
        color:$main-color;
        font-family: $font-bold;
        width:20px;
        margin-right:10px;
        display: flex;
        justify-content: flex-end;
    }

    .process-text {
        color:#fff;
        font-size:20px;
    }


    /* DISCOVER */

    .discover-edition {
        padding:80px 0;
        background:$main-color;
    }

    .discover-edition.edition2023 {
        background:#345d68;
    }

    .discover-edition h2 {
        color:#fff;
    }

    .discover-edition .row {
        margin-top:40px;
    }

    .discover-edition.edition2023 .row {
        display: flex;
        justify-content: center;
    }

    .discover-edition .col-33 {
        display: flex;
        justify-content: center;
    }

    .discover-edition a {
        width:240px;
        padding:15px 0;
        border-radius:10px;
        background:#345d68;
        color:#fff;
        display: flex;
        justify-content: center;
        font-size:25px;
        font-family: Arial, Helvetica, sans-serif;
        text-decoration: none;
        box-shadow: 6px 0 10px rgba(0,0,0,0.3);
        transition: 0.5s;
        cursor: pointer;
        margin:0 20px;
    }

    .discover-edition .btn-2023 {
        width:300px;
        padding:15px 0;
        border-radius:10px;
        background:$main-color;
        text-align: center;
        color:#fff;
        display: flex;
        justify-content: center;
        font-size:25px;
        font-family: Arial, Helvetica, sans-serif;
        text-decoration: none;
        box-shadow: 6px 0 10px rgba(0,0,0,0.3);
        transition: 0.5s;
        cursor: pointer;
        margin:0 20px;
    }

    .discover-edition .btn-2023:hover {
        background: darken($main-color, 10);
    }

    .discover-edition a:hover {
        background: darken(#345d68, 10);
    }

    .row-center {
        display: flex;
        justify-content: center;
    }

    /* CONVENTION HELP */

    .convention-help {
        padding:80px 0;
        background:#f1f1f1;
    }

    .convention-help img {
       // width:500px;
        max-width: 90%;
        height:auto;
        margin: 40px auto 0 auto;
        display: block;
    }

    /* TESTIMONIALS */

    .testimonials {
        padding:80px 0;
    }

    .testimonials-container {
        width:100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top:40px;
    }

    .testimonials-item {
        display: flex;
        justify-content: center;
        width:46%;
        margin:40px auto;
    }

    .testimonials-content {
        border:1px solid $text-color;
        border-radius:10px;
        padding:40px;
        max-width: 500px;
    }

    .testimonials-content img {
        display: block;
        margin: 0 auto;
        max-width: 40%;
        height:auto;
    }

    .testimonials-content h3 {
        margin-bottom:0;
        font-size:20px
    }

    .testimonials-content p {
        color: $text-color;
        font-size:20px;
        text-align: center;
    }

    .testimonials-content p.job {
        font-style: italic;
        margin-bottom: 20px;
    }

    /* ORGANIZER */

    .organizer {
        padding:80px 0;
        background:$main-color;
    }

    .organizer h2 {
        color:#fff;
    }

    .organizer h3 {
        font-size:20px;
        text-align: center;
        color: #fff;
        font-weight: 300;
    }

    .organizer p {
        font-size:20px;
        color: #fff;
        margin-bottom:20px;
        line-height: 1.7em;
        text-align: justify;
        font-weight: 300
    }

    .organizer p.blue-text {
        color:#345d68;
        font-weight:700;
    }

    .organizer .col-50 {
        width: 44%;
        margin: 0 auto;
    }

    .organizer .btn-banner {
        margin:40px auto 80px auto;
    }

    .organizer p.organizer-links {
        text-align: center;
        margin-top:40px;
        font-weight:500;
    }

    .organizer p.organizer-links a {
        color:#345d68;
        text-decoration: underline;
    }

    .organizer p.organizer-links a:hover {
        text-decoration: underline;
    }
    
    @media screen and (max-width:1530px) {
        .event-container .row {
            flex-direction: column;
            align-items: center;
        }

        .event-container .col-50 {
            width: 100%;
            display: flex;
            justify-content: center;
            margin:20px auto;
        }
    }

    @media screen and (max-width: 1080px) {


        .box-container {
            padding:0 20px;
            max-width: calc(100% - 40px);
        }

        .box-content .row {
            flex-direction: column;
        }

        .col-33 {
            width:100%;
        }

        .partner-row {
            flex-direction: column;
        }

    }

    @media screen and (max-width: 870px) {

        .banner {
            margin-top: 80px;
        }

        .banner h1.main-title {
            font-size:25px;
            margin-top: 0;
        }

        .banner h1, .banner h1 .subtitle{
            font-size:20px !important;
        }

        .btn-container {
            margin-top: 20px !important;
        }

        .discover-edition .row {
            flex-direction: column;
            align-items: center;
        }

        .discover-edition .col-33 {
            width: 100%;
            margin:20px auto;
        }

    }



    @media screen and (max-width: 768px) {
        .col-50, .program-container .col-50, .organizer .col-50 {
            width: 100%;
            margin-bottom:40px;
            flex-direction: column;
            align-items: center;
        }

        .row {
            flex-direction: column;
        }

        .intevenant-container .row {
            flex-direction: row;
        }

        p.intervenant {
            text-align: center;
        }

        .logo-orga {
            max-width: 400px;
            width: 80%;
        }

        .btn-container {
            flex-direction: column;
            align-items: center;
            margin-bottom: 80px;
            margin-top: 0;
            padding-bottom: 40px;
        }
        .btn-banner {
            margin-bottom: 20px;
        }

        .banner {
            height:auto;
            align-items: flex-start;
            margin-top: 80px;
        }
        
        .banner h1, .banner-text p {
            font-size: 30px;
            line-height: 40px;
        }

        .banner h1 .subtitle {
            font-size:25px;
        }


        .actions-container .col-50:first-child {
            border:none;
        }

        .intervenant-item img {
            margin-bottom: 20px;
        }

        .col-wheel {
            margin-bottom:0
        }

        
        .testimonials-item {
            width:94%;
        }

        .video-item {
            display: flex;
            justify-content: center;
        }

        .wheel-container p {
            text-align: center;
        }

        .wheel-container .col-50 {
            display: flex;
            justify-content: center;
        }

        .wheel-container .col-50 img {
            width: 400px;
        }


    }

    @media screen and (max-width: 600px) {
        .video-container iframe {
            height:350px;
        }

    }
</style>
